import { render, staticRenderFns } from "./SegmentationModels.vue?vue&type=template&id=4f10a320"
import script from "./SegmentationModels.vue?vue&type=script&lang=js"
export * from "./SegmentationModels.vue?vue&type=script&lang=js"
import style0 from "./SegmentationModels.vue?vue&type=style&index=0&id=4f10a320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports